"use client";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import type { SiteSettings } from "@/types";

interface FloatingWhatsAppProps {
  settings: SiteSettings | null;
}

export function FloatingWhatsApp({ settings }: FloatingWhatsAppProps) {
  const whatsappNumber =
    settings?.ctaButtons?.whatsapp?.number ||
    settings?.socialLinks?.whatsapp ||
    "+918592043363";

  const cleanNumber = whatsappNumber.replace(/\D/g, "");
  if (!cleanNumber) return null;

  return (
    <a
      href={`https://wa.me/${cleanNumber}?text=Hi%20MotoHome,%20I%20need%20a%20service%20for%20my%20bike.`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 hidden md:flex h-14 w-14 items-center justify-center rounded-full bg-green-500 text-white shadow-lg transition-transform hover:scale-110 hover:bg-green-600 active:scale-95"
    >
      <FontAwesomeIcon icon={faWhatsapp} className="h-7 w-7" />
    </a>
  );
}
